<template>
    <ul class="photo-box">

        <li 
            class="photo-item"
            v-for="v in list" 
            :key="v.id"
        >
            <img class="photo-item-img" v-if="v.photo !== ''" :src="v.photo">
            <p class="nickname">{{v.name}}</p>          
            <p class="position">{{v.post}}</p>          
        </li>
        <li class="flex-space-between-fix"></li>
    </ul>
</template>
<script>

export default {
    name: 'AboutUsPhoto',
    props: {
        list: Array
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@media screen and (min-width: 801px) {
    .photo-box {
        box-sizing: border-box;
        max-width: 1200px;
        padding-left: 144px;
        margin: 30px auto;
        overflow: hidden;
    }

    .photo-item {
        float: left;
        margin-right: 45px;
        width: 146px;
        height: 272px;
    }
    .photo-item-img {
        width: 146px;
        height: 146px;
        margin-bottom: 17px;
    }
    .nickname {
        font-size: 20px;
        color: #666;
        text-align: center;
        line-height: 1.5em;
    }
    .position {
        font-size: 20px;
        color: #666;
        text-align: center; 
        line-height: 1.5em;   
    }
    .flex-space-between-fix {
        display: none;
    }
}

@media screen and (max-width: 800px) {
    .photo-box {
        width: 7.6rem;
        display: flex; 
        justify-content: space-between; 
        align-items: center;
        flex-wrap:wrap;
        margin: 0 auto;
        overflow: hidden;
    }
    .flex-space-between-fix { 
        width: 100%; 
        height: 0; 
    }

    .photo-item {
        float: left;
        width: 1.97rem;
        height: 3.52rem;
    }
    .photo-item-img {
        width: 1.97rem;
        height: 1.97rem;
        margin-bottom: .16rem;
        /*height: 3.52rem;*/
    }
    .nickname {
        font-size: .32rem;
        color: #666;
        text-align: center;
    }
    .position {
        font-size: .32rem;
        line-height: .48rem;
        color: #666;
        text-align: center;    
    }
}

</style>